import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignIn from "./Components/LoginComp/signin";
import MainPanel from "./Components/BodyComp/main-panel";
import PrivateRoute from "./Utils/PrivateRoute";
import { auth, db } from "./Components/LoginComp/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { ToastContainer } from "react-toastify";
import ForgotPassword from "./Components/LoginComp/ForgotPassword";




const App = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        }
      } else {
        setUserRole(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
           <ToastContainer />
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />


        <Route
          path="/main-panel"
          element={
            <PrivateRoute role="admin" userRole={userRole}>
              <MainPanel />
            </PrivateRoute>
          }
        />



      </Routes>
   
    </Router>

    
  );
};

export default App;